/* eslint-disable no-param-reassign */
export function imageLoad(image: HTMLImageElement, callback: (image: HTMLImageElement, success: boolean) => void) {
    if (!image.complete) {
        image.onerror = () => {
            callback(image, false);

            image.onerror = null;
        };

        image.onload = () => {
            callback(image, true);
            image.onload = null;
        };
    } else if (image.naturalWidth === 0) {
        callback(image, false);
    } else {
        callback(image, true);
    }

    return {
        destroy() {},
    };
}
